App.controller('LifePzuCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', function ($scope, $sce, $state, $http, packageService, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'life_pzu';
    $scope.$emit('page', $scope.page);

    $scope.step = 'PZU Pomoc';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.life.start';
    $scope.$emit('link', $scope.link);
}]);